import React from "react"

import ColumnImage from "./ColumnImage"
import ColumnText from "./ColumnText"
import { Element, ElementProps } from "legacy/components/shared/base"
import { Maybe } from "types/Maybe"
import { ThreeColumnSectionItemType } from "types/shared-components"

interface OwnProps {
  alignment: ElementProps["textAlign"]
  data: Maybe<ThreeColumnSectionItemType>
  index: number
  totalItems: number
}

export type ColumnProps = OwnProps

function getMarginTop(index: number): string[] | number {
  switch (index) {
    case 0:
      return 0
    case 1:
      return ["45", "0"]
    case 2:
      return ["45", "75", "75", "0"]
    default:
      return ["45", "75"]
  }
}
const Column: React.FC<ColumnProps> = ({
  alignment,
  data,
  index,
  totalItems,
}): React.ReactElement | null => {
  const isLast = index === totalItems - 1
  const marginBottom = isLast ? ["0", "75"] : ["45", "75"]
  const marginTop = getMarginTop(index)

  if (!data) return null

  const { background_color, image, small_image } = data

  return (
    <Element
      flexDirection="column"
      gridColumn={["auto / span 12", "span 1"]}
      mb={marginBottom}
      mt={marginTop}
      mx="0"
      maxWidth="none"
    >
      <ColumnImage
        alignment={alignment}
        bgColor={background_color}
        imageData={image}
        small_image={small_image}
      />
      <ColumnText data={data} textAlign={alignment} />
    </Element>
  )
}

export default Column
